import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgGenderFemaleOutline = function SvgGenderFemaleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C9.23858 3.5 7 5.73858 7 8.5C7 11.2614 9.23858 13.5 12 13.5C14.7614 13.5 17 11.2614 17 8.5C17 5.73858 14.7614 3.5 12 3.5ZM5.5 8.5C5.5 4.91015 8.41015 2 12 2C15.5899 2 18.5 4.91015 18.5 8.5C18.5 11.8362 15.9866 14.5853 12.75 14.9572V17.5H15.25C15.6642 17.5 16 17.8358 16 18.25C16 18.6642 15.6642 19 15.25 19H12.75V21.25C12.75 21.6642 12.4142 22 12 22C11.5858 22 11.25 21.6642 11.25 21.25V19H8.75C8.33579 19 8 18.6642 8 18.25C8 17.8358 8.33579 17.5 8.75 17.5H11.25V14.9572C8.01342 14.5853 5.5 11.8362 5.5 8.5Z"
  })));
};

export { SvgGenderFemaleOutline as ReactComponent };
//# sourceMappingURL=gender--female-outline.svg.js.map
